import React, { useState } from 'react'
import { NavLink } from 'react-router-dom';
import './CustomBtn.scss';
import { useMediaQuery } from 'react-responsive';

export default function CustomBtn({
    type,
    title,
    on_click,
    link,
    state,
    bkg_color,
    bkg_color_hover,
    text_color,
    text_color_hover,
    border_color,
    border_color_hover,
    font_family,
    font_size = '16px',
    font_weight = 'normal',
    padding = '10px',
    border_radius,
    width,
    height,
    margin,
    letter_spacing,
    opacity,
    setIsHoveredFromParent = () => {},
    isSmallMobileBut = false,
    disabled,
    transform,
    transform_hover,
    box_shadow,
    box_shadow_hovered,
}) {

    const isSmallMobile = useMediaQuery({ maxWidth: 455 }); // Breakpoint pour SM

    const [isHovered, setIsHovered] = useState(false);

    const btnStyle = {
        backgroundColor: isHovered ? bkg_color_hover : bkg_color,
        color: isHovered ? text_color_hover : text_color,
        border: '1px solid ' + (isHovered ? border_color_hover : border_color),
        fontFamily: font_family,
        fontSize: /* isSmallMobile && !isSmallMobileBut ? '7.5vw' :  */font_size,
        fontWeight: font_weight,
        borderRadius: border_radius,
        width: isSmallMobile && !isSmallMobileBut ? '95%' : width,
        /* height: isSmallMobile ? '90px' : height, */
        margin: margin,
        letterSpacing: letter_spacing,
        transition: 'background-color 0.3s ease',
        cursor: 'pointer',
        opacity: opacity,
        transform: isHovered ? transform_hover : transform,
        boxShadow: isHovered ? box_shadow_hovered : box_shadow,
    };

    return (
        <div
            className='custom_btn'
            style={btnStyle}
            onMouseEnter={() => {
                setIsHovered(true)
                setIsHoveredFromParent(true)
            }}
            onMouseLeave={() => {
                setIsHovered(false)
                setIsHoveredFromParent(false)
            }}
            onClick={on_click}
        >
            {
                type === 'internal' ?
                    <NavLink
                        to={link}
                        className="custom_btn__link"
                        state={state}
                        style={{
                            padding: padding,
                        }}
                    >
                        {title}
                    </NavLink>
                    :
                        type === 'external' ?
                            <a
                                href={link}
                                className="custom_btn__link"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                    padding: padding,
                                }}
                            >
                                {title}
                            </a>
                        :
                            type === 'action' ?
                                <div
                                    className="custom_btn__link"
                                    style={{
                                        padding: padding,
                                        width: '100%',
                                        height: '100%',
                                    }}
                                >
                                    <span>{title}</span>
                                </div>
                            :
                                null
            }
        </div>
    )
}
